import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { SetupSearch } from 'areas/shared/pages/setup';
import { StatusFilter, UserTypeCombo } from 'areas/shared/controls'
import * as API from 'modules/app/API'

class Search extends SetupSearch {

    initialForm() {
        return {
            searchText: "",
            statusFilter: true,
            userTypeCode: null
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'role' }
        }
    }

    renderForm() {
        return (
            <Row>
                <Col md={5}>
                    <SearchBox
                        name="searchText"
                        placeholder="Search roles..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={3}>
                    <UserTypeCombo name="userTypeCode" clearable onChange={this.search} />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" onChange={this.search} entity="roles" />
                </Col>
            </Row>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/Search.js